export var isValidElement = function (jsxCode) {
    var jsxRegex = /react|\.jsx|children:\[\(|return\s+\S+.createElement\([^\)]*,/i;
    return jsxRegex.test(jsxCode);
};
